import PrivacyPolicy from '@/models/PrivacyPolicy'
import Terms from '@/models/Terms'
import Api from '@/api'

export default {
  namespaced: true,
  state: {
    privacyPolicyDetails: null,
    termsDetails: null
  },

  mutations: {
    setPrivacyPolicyDetails(state, privacyPolicy) {
      if (privacyPolicy instanceof PrivacyPolicy) {
        state.privacyPolicyDetails = privacyPolicy
      } else {
        state.privacyPolicyDetails = new PrivacyPolicy(privacyPolicy)
      }
    },

    clearPrivacyPolicyDetails(state) {
      state.privacyPolicyDetails = null
    },

    setTermsDetails(state, terms) {
      if (terms instanceof Terms) {
        state.termsDetails = terms
      } else {
        state.termsDetails = new Terms(terms)
      }
    },

    clearTermsDetails(state) {
      state.termsDetails = null
    }
  },

  actions: {
    async getPrivacyPolicyDetails({ commit }) {
      const { data } = await Api.get(`support/privacy-policy`)
      commit('setPrivacyPolicyDetails', data.data)
    },

    async getTermsDetails({ commit }) {
      const { data } = await Api.get(`support/terms-of-use`)
      commit('setTermsDetails', data.data)
    }
  }
}
